import React from 'react';
import './FourLogos.scss';

/**
 * Renders the four logos module
 * @param {string} title
 * @param {array} logos
 * @param {string} headingType
 * @param {string} backgroundColor
 * @returns {JSX.Element}
 * @constructor
 */
const FourLogos = ({ title, logos, headingType = '2', backgroundColor = 'gray' }) => {
  const Heading = `h${headingType}`;

  return (
    <div className={`c-four-logos background-color-${backgroundColor}`}>
      <div className="c-four-logos__inner">
        <div className={`c-four-logos__title ${Heading}-roobert`}>
          <Heading>{title}</Heading>
        </div>
        <div className="c-four-logos__logos-container">
          {logos.map((logo) =>
            !logo.link ? (
              <div className="c-four-logos__logo">
                <img src={logo.url} alt={logo.alt} />
              </div>
            ) : (
              <div className="c-four-logos__logo">
                <a href={logo.link} target={'_blank'}>
                  <img src={logo.url} alt={logo.alt} />
                </a>
              </div>
            ),
          )}
        </div>
      </div>
    </div>
  );
};

export default FourLogos;
